import ThumbnailsSelectable from './ThumbnailsSelectable'

export default ThumbnailsSelectable



// WEBPACK FOOTER //
// ./src/components/ThumbnailsSelectable/index.js